import { RestSlice } from '../../../../../redux/rest.slice';
import { IppReportPackageParameterGroup } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippParameterGroupsSlice = new RestSlice<IppReportPackageParameterGroup>(
	localizationService.getLocalizedString('ipp.reportPackage.templates.title'),
	Resource.IppReportPackageParameterGroups
);
export default ippParameterGroupsSlice.rests.reducer;
